import React, { useEffect, useState } from "react";
import Layout from "../components/Layout/Layout";

import { useAuth } from "../context/auth.js";
import axios, { all } from "axios";
import { useNavigate } from "react-router-dom";
import { Checkbox, Radio } from "antd";
import { Prices } from "../components/Prices.js";
import { useCard } from "../context/card.js";
import toast from "react-hot-toast";
import banner1 from "../images/banner1.png";
import "../styles/Home.css";

const HomePage = () => {
  const [auth, setAuth] = useAuth();

  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [checked, setChecked] = useState([]);
  const [radio, setRadio] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [card, setCard] = useCard();

  const navigate = useNavigate();

  //get products

  const getAllProducts = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`/api/v1/product/product-list/${page}`);
      setLoading(false);
      setProducts(data.products);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (!checked.length || !radio.length) getAllProducts();
  }, []);

  //get all category

  const getAllCategoryList = async () => {
    try {
      const { data } = await axios.get(`/api/v1/category/categoryList`);
      if (data?.success) {
        setCategories(data?.category);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllCategoryList();
    getTotalCount();
  }, []);

  //filter by category

  const handleCategoryFilter = (value, id) => {
    let All = [...checked];
    if (value) {
      All.push(id);
    } else {
      All = All.filter((c) => c !== id);
    }
    setChecked(All);
  };

  //get filtered product

  const filterProducts = async () => {
    try {
      const { data } = await axios.post(`/api/v1/product/product-filter`, {
        checked,
        radio,
      });
      setProducts(data?.products);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (checked.length || radio.length) filterProducts();
  }, [checked, radio]);

  // reset function
  const handleReset = () => {
    window.location.reload();
  };

  //get total count

  const getTotalCount = async () => {
    try {
      const { data } = await axios.get(`/api/v1/product/product-count`);
      setTotal(data?.total);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (page === 1) return;
    loadMore();
  }, [page]);

  const loadMore = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`/api/v1/product/product-list/${page}`);
      setLoading(false);
      setProducts([...products, ...data?.products]);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  return (
    <Layout title={" Products-3Sixteen Shopping"}>
      <div className="cl-md-12 banner mt-1">
        <img src={banner1} style={{ width: "100%", height: "300px" }} />
      </div>
      <hr />
      <div className="row mt-5  home-page">
        <div className="col-md-2  filters">
          <h6 className="text-center">Filter By Category</h6>
          <div
            className="d-flex flex-column ml-3"
            style={{ alignItems: "center" }}
          >
            {categories?.map((c) => (
              <Checkbox
                key={c._id}
                onChange={(e) => handleCategoryFilter(e.target.checked, c._id)}
              >
                {c.name}
              </Checkbox>
            ))}
          </div>
          {/* Price filter */}
          <p className="text-center mt-5 ">Filter By Price</p>
          <div
            className="d-flex flex-column ml-3"
            style={{ alignItems: "center" }}
          >
            <Radio.Group onChange={(e) => setRadio(e.target.value)}>
              {Prices?.map((pri) => (
                <div key={pri._id}>
                  <Radio value={pri.array}>{pri.name}</Radio>
                </div>
              ))}
            </Radio.Group>
          </div>
          <div
            className="d-flex flex-column mt-4"
            style={{ alignItems: "center" }}
          >
            <button
              className="btn btn-danger"
              style={{ width: "100px", borderRadius: "10px" }}
              onClick={handleReset}
            >
              Clear
            </button>
          </div>
        </div>
        <div className="col-md-10">
          <h2 className="text-center"> All Products</h2>
          <div className="d-flex flex-wrap  justify-content mt-5">
            {products?.map((item) => (
              <div
                className="card m-2"
                key={item._id}
                style={{ width: "18rem" }}
              >
                <img
                  src={`/api/v1/product/product-photo/${item._id}`}
                  className="card-img-top"
                  alt={item.name}
                />

                <div className="card-body">
                  <h5 className="card-title">{item.name}</h5>
                  <p className="card-text card-price">
                    {item.description.substring(0, 30)}
                  </p>
                  <p className="card-text">RS.{item.price}</p>

                  <button
                    className="btn btn-primary ms-1"
                    onClick={() => {
                      navigate(`product/${item.slug}`);
                    }}
                  >
                    More Details{" "}
                  </button>

                  <button
                    className="btn btn-warning ms-1"
                    onClick={() => {
                      setCard([...card, item]);
                      localStorage.setItem(
                        "cart",
                        JSON.stringify([...categories, item])
                      );
                      toast.success("Item Added to Cart Successfully");
                    }}
                  >
                    Add to Cart
                  </button>
                </div>
              </div>
            ))}
          </div>
          <div className="m-2 p-3">
            {products && products.length < total && (
              <button
                className="btn btn-warning"
                onClick={(e) => {
                  e.preventDefault();
                  setPage(page + 1);
                }}
              >
                {loading ? "Loading..." : "Loadmore"}
              </button>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default HomePage;
